import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";

import Pagination from "@components/pagination";
import { utcToTimezone } from "@utils/commonFunctions";
import { backDatedEventsListingHeader, routes, timezone, fsBackDatedStatus } from "@utils/constant";
import { TableStyle } from "./style";
import moment from "moment/moment";
import refreshIcon from "@assets/images/refresh.svg";
import uncheckedIcon from "@assets/images/uncheck-icon.svg";
import checkedIconOrange from "@assets/images/cheked-icon-orange.svg";
import { Link } from "react-router-dom";

function TableListing(props) {
  const classes = TableStyle();

  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending Review':
        return classes.statusPending;
      case 'Processing':
        return classes.statusProcessing;
      case 'Changes Applied':
        return classes.statusApplied;
      case 'Dismissed':
        return classes.statusDismissed;
      default:
        return "";
    }
  };

  const formatDateToTimezone = (date) => {
    return date ? utcToTimezone(date, timezone.SYDNEY, "DD-MM-YYYY HH:mm") + " NSW" : "N/A";
  }

  const hasPendingReview = props?.data?.rows?.some((item) => item.status === "Pending Review");

  return (
    <>
      <div className={classes.TableWrapper}>
        <TableContainer component={Paper} className={classes.customTable}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                {hasPendingReview && (
                  <TableCell className="check">
                    <FormControlLabel
                      className="custom-checkbox"
                      control={
                        <Checkbox
                          icon={
                            <img src={uncheckedIcon} alt="UnCheckBox" />
                          }
                          checkedIcon={
                            <img src={checkedIconOrange} alt="CheckBox" />
                          }
                          checked={props._mainCheck}
                          name="check"
                          onChange={(e) => props.handleMainChange(e)}
                        />
                      }
                    />
                  </TableCell>
                )}
                {backDatedEventsListingHeader.map((item, index) => {
                  return (
                    <TableCell key={index} className={item.className}>
                        {item?.className === "impactedPeriod" ? (
                          <Tooltip title={item.tooltipMessage} arrow placement="top">
                            <span>{item.title}</span>
                          </Tooltip>
                        ) : (
                          <span>{item.title}</span>
                        )}
                        {item.sort && (
                          <TableSortLabel
                            direction={
                              props.orderBy === item.sortTitle ? props.order : "desc"
                            }
                            active={true}
                            onClick={(e) => props.handleSorting(e, item)}
                          />
                        )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.data?.count === 0 ? (
                <TableRow className="noData">
                  <TableCell colSpan={backDatedEventsListingHeader.length + (hasPendingReview ? 1 : 0)}>
                    <span>No Data Found</span>
                  </TableCell>
                </TableRow>
              ) : (
                props?.data?.rows?.map((item) => (
                  <TableRow key={item.id}>
                    {hasPendingReview && (
                      (item.status === fsBackDatedStatus.pendingReview || item.status === fsBackDatedStatus.processing)? (
                        <TableCell className="check">
                          <FormControlLabel
                            className="custom-checkbox"
                            control={
                              <Checkbox
                                key={item._rowChecked ? 'checked' : 'unchecked'}
                                icon={
                                  <img src={uncheckedIcon} alt="UnCheckBox" />
                                }
                                checkedIcon={
                                  <img src={checkedIconOrange} alt="CheckBox" />
                                }
                                checked={item._rowChecked === true}
                                onChange={() => props.handleChange(item)}
                                name="check"
                              />
                            }
                          />
                        </TableCell>
                      ) : (
                        <TableCell className="check" />
                      )
                    )}
                    <TableCell className="customer">
                      {item?.customers && item?.cities ? (
                        <Link
                          to={`${routes.customerDetail}/${item?.customers?.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.customers?.name + " - " + item?.cities?.name}
                        </Link>
                        ) : (
                          "-"
                        )
                      }
                    </TableCell>
                    <TableCell className="impactedPeriod">
                      {item?.impactPeriodStart ? (
                        <>
                          {moment(item.impactPeriodStart).format("DD-MM-YYYY")} →
                          <br />
                          {moment(item.fuelSurcharges?.endDate ?? moment()).format("DD-MM-YYYY")}
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell className="newRate">
                      {item.fuelSurcharges?.fuelSurcharge ? item.fuelSurcharges?.fuelSurcharge + "%" : "0"}
                    </TableCell>
                    <TableCell className="impactedJobs">
                      {item?.impactedJobsCount ?? "-"}
                    </TableCell>
                    <TableCell className="impactedDraftInvoices">
                      {item?.impactedInvoicesCount ?? "-"}
                    </TableCell>
                    <TableCell className="lastUpdate">
                      {item?.updatedAt && formatDateToTimezone(item.updatedAt)}
                    </TableCell>
                    <TableCell className="status">
                      <p className={`${classes.status} ${getStatusClass(item?.status)}`}>
                        {item?.status ?? "-"}
                      </p>
                    </TableCell>
                    <TableCell className="action">
                      {(item?.status === fsBackDatedStatus.pendingReview ||
                        item?.status === fsBackDatedStatus.processing) && (
                        <span>
                          <span
                            className={[classes.refresh, item?.status === fsBackDatedStatus.processing ? classes.hiddenRefresh : props.refreshRows[item.id] ? classes.spin : ''].join(' ')}
                            onClick={() => {
                              props.refreshJobAndInvoiceImpacted(item);
                            }}
                          >
                            <img
                              src={refreshIcon}
                              alt="refresh icon"
                              width={28}
                              height={28}
                            />
                          </span>
                          <span className={classes.review}>
                            <Link to={`${routes.backDatedEventDetail}/${item.id}`}>Review</Link>
                          </span>
                          <span
                            className={classes.dismiss}
                            onClick={() => {
                              props.handleDismiss(item);
                            }}
                          > Dismiss</span>
                        </span>
                      )}

                      {item?.status === "Changes Applied" && (
                        <span className={classes.viewLog}><Link to={`${routes.backDatedEventsLog}/${item?.id}`}>View Log</Link></span>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {props?.data?.count !== 0 && (
          <div className="pagination-wrapper">
            <Pagination
              count={props.count}
              page={props.page}
              handleChangePage={props.handleChangePage}
              rowsPerPage={props.rowsPerPage}
              handleChangeRowsPerPage={props.handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </>
  );
}
export default TableListing;
